var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.orderOptions,"label":"Sort order","outlined":""},model:{value:(_vm.orderLabel),callback:function ($$v) {_vm.orderLabel=$$v},expression:"orderLabel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }